import React from "react";
import NoticeForm from "./NoticeForm";
import { useForm } from "react-hook-form";
import Card from "../Reusable/Card";
//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { createNoticeValidationForm } from "../../utils/validationSchemas";
const CreateNotice = (props: any) => {
  const { handleCreate, isPostLoading } = props;
  const {
    handleSubmit,
    register,
    setValue,
    setError,
    watch,
    getValues,
    control,
    clearErrors,
    formState: { errors },
  } = useForm<any>({
    resolver: yupResolver(createNoticeValidationForm),
  });
  return (
    <>
      <FormLayout
        handleSubmit={handleSubmit}
        handleFormSubmit={handleCreate}
        setError={setError}
        buttonLabel={"Create"}
        isLoading={isPostLoading}
      >
        <NoticeForm
          register={register}
          setValue={setValue}
          getValues={getValues}
          setError={setError}
          errors={errors}
          watch={watch}
          control={control}
          clearErrors={clearErrors}
        />
      </FormLayout>
    </>
  );
};

export default CreateNotice;
